export class Patient {
  constructor(
    public id?: number,
    public name?: string,
    public email?: string,
    public occupation?: string,
    public gender?: number,
    public dob?: Date,
    public mother_name?: string,
    public mother_phone?: string,
    public father_name?: string,
    public father_phone?: string,
    public address?: string,
    public city?: string,
    public state?: string,
    public zip?: string,
    public homephone?: string,
    public cellphone?: string
  ) {}

  public static getCurrentAge(patient: Patient): string {
    if (!patient.dob) return '';

    //@ts-ignore
    let dobSplit = patient.dob.split('-');

    let dob = new Date(dobSplit[0], (parseInt(dobSplit[1]) - 1), dobSplit[2]);
    let dobMonth = dob.getMonth();
    let dobDay = dob.getDate();

    let today = new Date();
    let todayMonth = today.getMonth();
    let todayDay = today.getDate();

    let diffMths = 0;

    if (dobMonth == todayMonth) {

      if (dobDay > todayDay) {
        diffMths = 11;
      } else {
        diffMths = 0;
      }

    } else {

      if (dobMonth > todayMonth) {
        diffMths = (12 - (dobMonth - todayMonth));

      } else {
        diffMths = todayMonth - dobMonth;
      }

      if (dobDay > todayDay) {
        diffMths = diffMths - 1;
      }
    }

    let diffMs = Math.abs((new Date()).valueOf() - (new Date(patient.dob)).valueOf());
    let diffYrs = diffMs / 31536000000;

    return `${Math.floor(diffYrs)} anos e ${diffMths} meses`;
  }
}
